<template>
  <div>
    <div class="row tfacontainer">
      <div class="row col-12 justify-content-center ">
        <i class="i-evollu-black mt-4" style="height: 55px"/>
      </div>
      <div class="row col-12 justify-content-center" style="margin-top: 40px">
        <h3>{{ $t('auth.tfa.title') }}</h3>
      </div>
      <div class="row col-12 justify-content-center" style="margin-top: 40px; font-size: 18px">
        <span>{{ $t('auth.tfa.mail_sent') }}</span>
        <p> {{$t('auth.tfa.please_insert_code')}} </p>
      </div>
      <div class="row col-9 justify-content-center flex-column" style="margin-top: 40px">
        <!--<label style="">{{$t('auth.two_factor_code')}}</label>-->
        <input
          :disabled="validCode"
          @input="error = null"
          v-model="twoFactorCode"
          type="text"
          class="rounded-input"
          :placeholder="$t('auth.two_factor_code')"
          maxlength="6"
        >
      </div>
      <div v-if="error !== null" class="row col-12 justify-content-center" style="margin-top: 10px; font-size: 16px; color: #9b0909">
        <span>{{ error }}</span>
      </div>
      <div class="row col-12 justify-content-center" style="margin-top: 40px">
        <span>{{$t('auth.tfa.code_not_received_1')}}<a href="#" class="" @click="generateCode">{{$t('auth.tfa.code_not_received_2')}}</a>.</span>
      </div>
      <div class="row col-12 justify-content-center" style="margin-top: 30px; margin-bottom: 20px; ">
        <va-button
          :disabled="twoFactorCode.length !== 6 || isValidating || validCode"
          @click.prevent="verifyCode">
          {{$t('ranu.records.validate')}}
        </va-button>
      </div>
      <div class="row col-12 justify-content-center" v-if="isLoading">
        <hollow-dots-spinner
          :animation-duration="1000"
          :size="60"
          color="#29c4a9"
        />
      </div>

    </div>
  </div>

</template>

<script>
import LocalStorageHelper from '@/local-storage/LocalStorageHelper';
import { TwoFactorAuthService } from '@/api/AuthService';
import { HollowDotsSpinner } from 'epic-spinners'

export default {
  name: 'index',
  components: {HollowDotsSpinner },
  data() {
    return {
      isValidating: false,
      twoFactorCode: '',
      error: null,
      validCode: false,
      isLoading: false,
    }
  },
  mounted() {
    if(this.$auth.user().id) {
      this.$router.replace({name: 'profile'})
    }
  },
  beforeRouteEnter(to, from, next) {
    if(LocalStorageHelper.get('default_auth_token', false) === null) {
      next('login')
      return
    }
    next()
  },
  beforeRouteLeave(to, from, next) {
    if(this.$auth.user().id === undefined) {
      return
    }
    next()
  },
  methods: {
    generateCode: async function() {
      try {
        await TwoFactorAuthService.generateTwoFactorCodeAndSendEmail()
      } catch (error) {
        console.log(error)
      }
    },
    verifyCode: async function() {
      const data = {
        code: this.twoFactorCode
      }
      this.isValidating = true
      try {
        this.isLoading = true
        await TwoFactorAuthService.validateTwoFactorCode(data)
        this.validCode = true
        this.isValidating = false
        this.$auth.fetch()
      } catch (error) {
        if(error.error === 'tfa_code_expired') {
          this.error = this.$t('auth.tfa.errors.code_expired')
        } else if (error.error === 'no_match_found') {
          this.error = this.$t('auth.tfa.errors.no_match')
        } else {
          this.error = this.$t('auth.tfa.errors.generic')
        }
        this.twoFactorCode = ''
        this.isValidating = false
        this.isLoading = false
      }

    },
    handleBeforeUnload() {
      localStorage.clear();
    },
  },
  created() {
    this.generateCode()
    window.addEventListener('beforeunload', this.handleBeforeUnload);
  },
  destroyed() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  },
};
</script>

<style scoped lang="scss">
.tfacontainer {
  max-width: 700px;
  //height: 700px;
  background-color: #dadada;
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 40px;
  box-shadow: 12px 12px 12px rgba(0, 0, 0, 0.1);
}

.rounded-input {
  border-radius: 20px; /* Adjust the border-radius to control the roundness */
  padding: 10px; /* Add padding for spacing */
  border: 1px solid #ccc; /* Add border for visual separation */
  outline: none; /* Remove default focus outline */
}

/* Optional: Add styles for focus state */
.rounded-input:focus {
  border-color: #7dca52; /* Change border color on focus */
  box-shadow: 0 0 5px #7dca52; /* Add shadow effect on focus */
}

.loading {
  margin-top: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 40%;
  left: 50%;
}

</style>
